let country_arry = [
  { label: "Afghanistan", value: "afghanistan" },
  { label: "Albania", value: "albania" },
  { label: "Algeria", value: "algeria" },
  { label: "Andorra", value: "andorra" },
  { label: "Angola", value: "angola" },
  { label: "Antigua and Barbuda", value: "antigua_and_barbuda" },
  { label: "Argentina", value: "argentina" },
  { label: "Armenia", value: "armenia" },
  { label: "Australia", value: "australia" },
  { label: "Austria", value: "austria" },
  { label: "Azerbaijan", value: "azerbaijan" },
  { label: "Bahamas", value: "bahamas" },
  { label: "Bahrain", value: "bahrain" },
  { label: "Bangladesh", value: "bangladesh" },
  { label: "Barbados", value: "barbados" },
  { label: "Belarus", value: "belarus" },
  { label: "Belgium", value: "belgium" },
  { label: "Belize", value: "belize" },
  { label: "Benin", value: "benin" },
  { label: "Bhutan", value: "bhutan" },
  { label: "Bolivia", value: "bolivia" },
  {
    label: "Bosnia and Herzegovina",
    value: "bosnia_and_herzegovina",
  },
  { label: "Botswana", value: "botswana" },
  { label: "Brazil", value: "brazil" },
  { label: "Brunei", value: "brunei" },
  { label: "Bulgaria", value: "bulgaria" },
  { label: "Burkina Faso", value: "burkina_faso" },
  { label: "Burundi", value: "burundi" },
  { label: "Cabo Verde", value: "cabo_verde" },
  { label: "Cambodia", value: "cambodia" },
  { label: "Cameroon", value: "cameroon" },
  { label: "Canada", value: "canada" },
  {
    label: "Central African Republic",
    value: "central_african_republic",
  },
  { label: "Chad", value: "chad" },
  { label: "Chile", value: "chile" },
  { label: "China", value: "china" },
  { label: "Colombia", value: "colombia" },
  { label: "Comoros", value: "comoros" },
  { label: "Costa Rica", value: "costa_rica" },
  { label: "Croatia", value: "croatia" },
  { label: "Cuba", value: "cuba" },
  { label: "Cyprus", value: "cyprus" },
  { label: "Czech Republic", value: "czech_republic" },
  { label: "Denmark", value: "denmark" },
  { label: "Djibouti", value: "djibouti" },
  { label: "Dominica", value: "dominica" },
  { label: "Dominican Republic", value: "dominican_republic" },
  { label: "Ecuador", value: "ecuador" },
  { label: "Egypt", value: "egypt" },
  { label: "El Salvador", value: "el_salvador" },
  { label: "Equatorial Guinea", value: "equatorial_guinea" },
  { label: "Eritrea", value: "eritrea" },
  { label: "Estonia", value: "estonia" },
  { label: "Eswatini", value: "eswatini" },
  { label: "Ethiopia", value: "ethiopia" },
  { label: "Fiji", value: "fiji" },
  { label: "Finland", value: "finland" },
  { label: "France", value: "france" },
  { label: "Gabon", value: "gabon" },
  { label: "Gambia", value: "gambia" },
  { label: "Georgia", value: "georgia" },
  { label: "Germany", value: "germany" },
  { label: "Ghana", value: "ghana" },
  { label: "Greece", value: "greece" },
  { label: "Grenada", value: "grenada" },
  { label: "Guatemala", value: "guatemala" },
  { label: "Guinea", value: "guinea" },
  { label: "Guinea-Bissau", value: "guinea_bissau" },
  { label: "Guyana", value: "guyana" },
  { label: "Haiti", value: "haiti" },
  { label: "Honduras", value: "honduras" },
  { label: "Hungary", value: "hungary" },
  { label: "Iceland", value: "iceland" },
  { label: "India", value: "india" },
  { label: "Indonesia", value: "indonesia" },
  { label: "Iran", value: "iran" },
  { label: "Iraq", value: "iraq" },
  { label: "Ireland", value: "ireland" },
  { label: "Israel", value: "israel" },
  { label: "Italy", value: "italy" },
  { label: "Jamaica", value: "jamaica" },
  { label: "Japan", value: "japan" },
  { label: "Jordan", value: "jordan" },
  { label: "Kazakhstan", value: "kazakhstan" },
  { label: "Kenya", value: "kenya" },
  { label: "Kiribati", value: "kiribati" },
  { label: "Kuwait", value: "kuwait" },
  { label: "Kyrgyzstan", value: "kyrgyzstan" },
  { label: "Laos", value: "laos" },
  { label: "Latvia", value: "latvia" },
  { label: "Lebanon", value: "lebanon" },
  { label: "Lesotho", value: "lesotho" },
  { label: "Liberia", value: "liberia" },
  { label: "Libya", value: "libya" },
  { label: "Liechtenstein", value: "liechtenstein" },
  { label: "Lithuania", value: "lithuania" },
  { label: "Luxembourg", value: "luxembourg" },
  { label: "Madagascar", value: "madagascar" },
  { label: "Malawi", value: "malawi" },
  { label: "Malaysia", value: "malaysia" },
  { label: "Maldives", value: "maldives" },
  { label: "Mali", value: "mali" },
  { label: "Malta", value: "malta" },
  { label: "Marshall Islands", value: "marshall_islands" },
  { label: "Mauritania", value: "mauritania" },
  { label: "Mauritius", value: "mauritius" },
  { label: "Mexico", value: "mexico" },
  { label: "Micronesia", value: "micronesia" },
  { label: "Moldova", value: "moldova" },
  { label: "Monaco", value: "monaco" },
  { label: "Mongolia", value: "mongolia" },
  { label: "Montenegro", value: "montenegro" },
  { label: "Morocco", value: "morocco" },
  { label: "Mozambique", value: "mozambique" },
  { label: "Myanmar", value: "myanmar" },
  { label: "Namibia", value: "namibia" },
  { label: "Nauru", value: "nauru" },
  { label: "Nepal", value: "nepal" },
  { label: "Netherlands", value: "netherlands" },
  { label: "New Zealand", value: "new_zealand" },
  { label: "Nicaragua", value: "nicaragua" },
  { label: "Niger", value: "niger" },
  { label: "Nigeria", value: "nigeria" },
  { label: "North Korea", value: "north_korea" },
  { label: "North Macedonia", value: "north_macedonia" },
  { label: "Norway", value: "norway" },
  { label: "Oman", value: "oman" },
  { label: "Pakistan", value: "pakistan" },
  { label: "Palau", value: "palau" },
  { label: "Panama", value: "panama" },
  { label: "Papua New Guinea", value: "papua_new_guinea" },
  { label: "Paraguay", value: "paraguay" },
  { label: "Peru", value: "peru" },
  { label: "Philippines", value: "philippines" },
  { label: "Poland", value: "poland" },
  { label: "Portugal", value: "portugal" },
  { label: "Qatar", value: "qatar" },
  { label: "Romania", value: "romania" },
  { label: "Russia", value: "russia" },
  { label: "Rwanda", value: "rwanda" },
  {
    label: "Saint Kitts and Nevis",
    value: "saint_kitts_and_nevis",
  },
  { label: "Saint Lucia", value: "saint_lucia" },
  {
    label: "Saint Vincent and the Grenadines",
    value: "saint_vincent_and_the_grenadines",
  },
  { label: "Samoa", value: "samoa" },
  { label: "San Marino", value: "san_marino" },
  {
    label: "Sao Tome and Principe",
    value: "sao_tome_and_principe",
  },
  { label: "Saudi Arabia", value: "saudi_arabia" },
  { label: "Senegal", value: "senegal" },
  { label: "Serbia", value: "serbia" },
  { label: "Seychelles", value: "seychelles" },
  { label: "Sierra Leone", value: "sierra_leone" },
  { label: "Singapore", value: "singapore" },
  { label: "Slovakia", value: "slovakia" },
  { label: "Slovenia", value: "slovenia" },
  { label: "Solomon Islands", value: "solomon_islands" },
  { label: "Somalia", value: "somalia" },
  { label: "South Africa", value: "south_africa" },
  { label: "South Korea", value: "south_korea" },
  { label: "South Sudan", value: "south_sudan" },
  { label: "Spain", value: "spain" },
  { label: "Sri Lanka", value: "sri_lanka" },
  { label: "Sudan", value: "sudan" },
  { label: "Suriname", value: "suriname" },
  { label: "Sweden", value: "sweden" },
  { label: "Switzerland", value: "switzerland" },
  { label: "Syria", value: "syria" },
  { label: "Taiwan", value: "taiwan" },
  { label: "Tajikistan", value: "tajikistan" },
  { label: "Tanzania", value: "tanzania" },
  { label: "Thailand", value: "thailand" },
  { label: "Timor-Leste", value: "timor_leste" },
  { label: "Togo", value: "togo" },
  { label: "Tonga", value: "tonga" },
  { label: "Trinidad and Tobago", value: "trinidad_and_tobago" },
  { label: "Tunisia", value: "tunisia" },
  { label: "Turkey", value: "turkey" },
  { label: "Turkmenistan", value: "turkmenistan" },
  { label: "Tuvalu", value: "tuvalu" },
  { label: "Uganda", value: "uganda" },
  { label: "Ukraine", value: "ukraine" },
  { label: "United Arab Emirates", value: "united_arab_emirates" },
  { label: "United Kingdom", value: "united_kingdom" },
  { label: "United States", value: "united_states" },
  { label: "Uruguay", value: "uruguay" },
  { label: "Uzbekistan", value: "uzbekistan" },
  { label: "Vanuatu", value: "vanuatu" },
  { label: "Vatican City", value: "vatican_city" },
  { label: "Venezuela", value: "venezuela" },
  { label: "Vietnam", value: "vietnam" },
  { label: "Yemen", value: "yemen" },
  { label: "Zambia", value: "zambia" },
  { label: "Zimbabwe", value: "zimbabwe" },
];

export const visa_application = [
  // ============================================================
  // GETTING STARTED
  // ============================================================
  {
    title: "Getting Started",
    value: "getting_started",
    has_sub_sections: false,
    is_completed: false,
    _id: "683d30eb8ed9ddeb5b99b4df",
    questions: [
      {
        question_statement: `By proceeding with the Little Haiti Global Resettlement Program application, the participant
        certifies that they meet all basic eligibility requirements, including being at least eighteen (18)
        years of age, holding Haitian nationality, and having no criminal record. The participant further
        certifies financial readiness to pay the non-refundable Application Processing Fee of $1,500 USD 
        upon submission and acknowledges the obligation to pay the required Investment Fee of $10,000 USD 
        following initial application approval. The participant understands that participation in
        the program requires the timely submission of all supporting documentation, including but not
        limited to passport details, passport photograph, visa information, and other verification
        materials as requested. By agreeing to this Eligibility Certification Statement, the participant
        affirms the accuracy of the information provided, acknowledges that eligibility does not
        guarantee final acceptance, and agrees to comply with all program requirements as part of the
        Getting Started process. `,
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: true,
        created_for: "eligibility_certification_statement",
        question_id: "7RbqEO",
      },
    ],
  },
  // ============================================================
  // CRIMINAL, IMMIGRATION, AND TRAVEL HISTORY DISCLOSURE
  // ============================================================
  {
    title: "Criminal, Immigration, and Travel History Disclosure",
    value: "criminal_record",
    has_sub_sections: false,
    is_completed: false,
    _id: "683d30eb8ed9ddeb5b99b4e6",
    questions: [
      {
        question_statement: `Have you ever pleaded guilty or no contest to, or been convicted of, any criminal offense
        in Haiti, the United States, or any other country where you have resided?`,
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: true,
        created_for: "criminal_record",
        question_id: "Z6bqEO",
      },
      {
        question_statement: `Have you ever been arrested in Haiti, the United States, or any other country where you
        currently reside or have previously resided?`,
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: true,
        created_for: "criminal_record_two",
        question_id: "Z7bqEO",
      },
      {
        question_statement: `Do you have any pending criminal charges in Haiti, the United States, or any other
        country where you reside?`,
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: true,
        created_for: "criminal_record_three",
        question_id: "Z8bqEO",
      },
      {
        question_statement: `Have you ever been convicted of a felony in Haiti, the United States, or any other country
        where you have resided?`,
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: true,
        created_for: "criminal_record_five",
        question_id: "Z9bqEO",
      },
      {
        question_statement: `Have you ever been refused a visa, refused entry, or denied admission to the host
        country?`,
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: true,
        created_for: "visa_refusal",
        question_id: "Z9cqEO",
      },
      {
        question_statement: `Applicants who answer <strong>“Yes”</strong> to any question may be required to provide additional details and
        supporting documentation. Failure to disclose complete and accurate information may result in
         denial or disqualification from the Little Haiti Global Resettlement Program.`,
        question_type: "description",
        is_required: false,
        created_for: "submit",
        question_id: "Z9098s",
        is_not_show_ans: true,
      },
    ],
  },
  // ============================================================
  // BACKGROUND CHECK DISCLOSURES & CONSENT
  // ============================================================
  {
    title: "Background Check Disclosures & Consent",
    value: "background_check_disclosures",
    has_sub_sections: false,
    is_completed: false,
    _id: "683d30eb8ed9ddeb5b99c4f7",
    intro_text: `By completing this section, the applicant acknowledges that the Little Haiti Global (LHG)
    Resettlement Program may conduct background, criminal, and immigration-related verifications
    as part of the eligibility and review process. The applicant certifies that all responses are true,
    complete, and accurate to the best of their knowledge and understands that any omission or
    misrepresentation may result in denial or disqualification from the program.`,
    questions: [
      {
        question_statement: `Have you ever visited the host country in the past?`,
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: true,
        created_for: "past_visited_country",
        question_id: "BG_ACK1",
      },
      {
        question_statement: `I acknowledge receipt of the Disclosure Regarding Background Investigation, California CRA Disclosure, Summary of Your Rights - FCRA, and Acknowledgement and Authorisation for Background Check.`,
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: true,
        created_for: "acknowledge_documents",
        question_id: "BG_ACK2",
      },
      {
        question_statement: `I hereby consent to a Criminal Background Check being conducted using the information I have provided in my application.`,
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: true,
        created_for: "consent_background_check",
        question_id: "BG_ACK3",
      },
    ],
  },
  // ============================================================
  // VISA TYPE & APPLICATION DETAILS
  // ============================================================
  {
    title: "Visa Type & Application Details",
    value: "visa_type_and_application_details",
    has_sub_sections: false,
    is_completed: false,
    _id: "683d30eb8ed9ddeb5b99b4e1",
    questions: [
      {
        question_statement: `Visa Type`,
        question_type: "heading",
        is_required: false,
        created_for: "visa_type_heading",
        question_id: "VT_H1",
        is_not_show_ans: true,
      },
      {
        question_statement: `Please select your visa type:`,
        question_type: "radio",
        options: [
          {
            label: `Visa G-100: I currently reside in the United States.`,
            value: "g100",
          },
          {
            label: `Visa G-200: I live outside the United States, Canada, or France and do not have legal status (e.g., in countries such as Haiti, the Dominican Republic, Chile, Venezuela, Mexico, Brazil, etc.).`,
            value: "g200",
          },
        ],
        answer: "",
        is_required: true,
        created_for: "visa_type_and_preliminary_info",
        question_id: "8RbqEO",
      },
      {
        question_statement: `Application Details`,
        question_type: "heading",
        is_required: false,
        created_for: "application_details_heading",
        question_id: "AD_H1",
        is_not_show_ans: true,
      },
      {
        question_statement: `Country of Residence`,
        question_type: "dropdown",
        options: country_arry,
        answer: "",
        is_required: true,
        created_for: "country_of_residence",
        question_id: "9RbqEO",
      },
      {
        question_statement: `Nationality`,
        question_type: "dropdown",
        options: [
          { label: "Haitian", value: "haitian" },
          { label: "Other", value: "other" },
        ],
        answer: "",
        is_required: true,
        created_for: "current_nationality",
        question_id: "1RbqEO",
      },
      {
        question_statement: `Nationality at Birth`,
        question_type: "dropdown",
        options: country_arry,
        answer: "",
        is_required: true,
        created_for: "nationality_at_birth",
        question_id: "2RbqEO",
      },
    ],
  },
  // ============================================================
  // HOUSING DETAILS - Hidden
  // ============================================================
  // {
  //   title: 'Housing Details',
  //   value: 'housing_option',
  //   has_sub_sections: false,
  //   is_completed: false,
  //   _id: '683d30eb8ed9ddeb5b99b4ec',
  //   questions: [
  //     {
  //       question_statement: 'Do you want to include a housing package in your application?',
  //       question_type: 'radio',
  //       options: [
  //         { label: 'Yes', value: 'yes' },
  //         { label: 'No', value: 'no' },
  //       ],
  //       answer: '',
  //       is_required: true,
  //       created_for: 'housing_need',
  //       question_id: 'H1bqEO',
  //     },
  //     {
  //       question_statement: 'Housing Category',
  //       question_type: 'dropdown',
  //       options: [
  //         { label: 'Standard', value: 'standard' },
  //         { label: 'Luxury', value: 'luxury' },
  //       ],
  //       answer: '',
  //       is_required: true,
  //       created_for: 'housing_category',
  //       question_id: 'H2bqEO',
  //     },
  //     {
  //       question_statement: 'Housing Type',
  //       question_type: 'dropdown',
  //       options: [
  //         { label: 'House', value: 'house' },
  //         { label: 'Room', value: 'room' },
  //       ],
  //       answer: '',
  //       is_required: true,
  //       created_for: 'housing_type',
  //       question_id: 'H5bqEO',
  //     },
  //     {
  //       question_statement: 'Preferred Location',
  //       question_type: 'text',
  //       answer: '',
  //       is_required: true,
  //       created_for: 'preferred_location',
  //       question_id: 'H3bqEO',
  //     },
  //     {
  //       question_statement: 'Additional Requirement',
  //       question_type: 'text',
  //       answer: '',
  //       is_required: false,
  //       created_for: 'additional_requirement',
  //       question_id: 'H4bqEO',
  //     },
  //   ],
  // },
  {
    // Comment This when un-hidden the original housing details
    title: 'Housing Details',
    value: 'housing_option',
    has_sub_sections: false,
    is_completed: true,
    hide_section: true,
    _id: '683d30eb8ed9ddeb5b99b4ec',
    questions: [
      {
        question_statement: 'Do you want to include a housing package in your application?',
        question_type: 'radio',
        options: [
          { label: 'Yes', value: 'yes' },
          { label: 'No', value: 'no' },
        ],
        answer: 'no',
        is_required: true,
        created_for: 'housing_need',
        question_id: 'H1bqEO',
      },
    ],
  },
  // ============================================================
  // PERSONAL INFORMATION ABOUT THE APPLICANT
  // ============================================================
  {
    title: "Personal Information about the Applicant",
    value: "personal_information_about_the_applicant",
    has_sub_sections: false,
    is_completed: false,
    _id: "683d30eb8ed9ddeb5b99b4e4",
    questions: [
      {
        question_statement: `Choose Title`,
        question_type: "dropdown",
        options: [
          { label: "Mr.", value: "mr" },
          { label: "Mrs.", value: "mrs" },
          { label: "Ms.", value: "ms" },
          { label: "Dr.", value: "dr" },
          { label: "Miss", value: "miss" },
        ],
        answer: "",
        is_required: false,
        created_for: "title_personal_info",
        question_id: "4NbqEO",
      },

      {
        question_statement: `First Name`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "passport_first_name",
        question_id: "4ObqEO",
      },
      {
        question_statement: `Last name`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "passport_last_name",
        question_id: "4PbqEO",
      },
      {
        question_statement: `Middle Name`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: false,
        created_for: "passport_middle_name",
        question_id: "4QbqEO",
      },
      {
        question_statement: `Other Name`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: false,
        created_for: "other_name",
        question_id: "4RbqEO",
      },
      {
        question_statement: `Gender`,
        question_type: "dropdown",
        options: [
          { label: "Male", value: "male" },
          { label: "Female", value: "female" },
          { label: "Other", value: "other" },
          { label: "Prefer not to say", value: "prefer_not_to_say" },
        ],
        answer: "",
        is_required: true,
        created_for: "gender",
        question_id: "4SbqEO",
      },
      {
        question_statement: `Address`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "address",
        question_id: "4UbqEK",
      },
      {
        question_statement: `Address Line 2`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: false,
        created_for: "address_line",
        question_id: "4UbqEK",
      },
      {
        question_statement: `City`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "city",
        question_id: "4TbqEO",
      },
      {
        question_statement: `State/Province/Territory`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "state",
        question_id: "4UbqEO",
      },

      {
        question_statement: `Zip code or Country code`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "zip_code_or_country_code",
        question_id: "4VbqEO",
      },
      {
        question_statement: `Country`,
        question_type: "dropdown",
        options: country_arry,
        answer: "",
        is_required: true,
        created_for: "country",
        question_id: "4WbqEO",
      },
      {
        question_statement: `Phone Number`,
        question_type: "text",
        type: "number",
        answer: "",
        is_required: true,
        created_for: "phone_number",
        question_id: "4XbqEO",
      },
      {
        question_statement: `Marital Status`,
        question_type: "dropdown",
        options: [
          { label: "Single", value: "single" },
          { label: "Married", value: "married" },
          { label: "Divorced", value: "divorced" },
          { label: "Widowed", value: "widowed" },
        ],
        answer: "",
        is_required: true,
        created_for: "marital_status",
        question_id: "4YbqEO",
      },
      {
        question_statement: `Date of Birth`,
        question_type: "date",
        type: "date",
        answer: "",
        is_required: true,
        created_for: "date_of_birth",
        question_id: "4ZbqEO",
      },
      {
        question_statement: `Place of Birth`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "place_of_birth",
        question_id: "Z0bqEO",
      },
      {
        question_statement: `Profession/Occupation`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: false,
        created_for: "profession_or_occupation",
        question_id: "Z1bqEO",
      },
    ],
  },
  // ============================================================
  // PASSPORT DETAILS
  // ============================================================
  {
    title: "Passport Details",
    value: "passport_details",
    _id: "683d30eb8ed9ddeb5b99b4e5",
    has_sub_sections: false,
    is_completed: false,
    questions: [
      {
        question_statement: `Passport Number`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "passport_number",
        question_id: "Z2bqEO",
      },
      {
        question_statement: `Country of Issue`,
        question_type: "dropdown",
        options: country_arry,
        answer: "",
        is_required: true,
        created_for: "country_of_issue",
        question_id: "Z3bqEO",
      },
      {
        question_statement: `Date of Issue`,
        question_type: "date",
        type: "date",
        answer: "",
        is_required: true,
        created_for: "date_of_issue",
        question_id: "Z4bqEO",
      },
      {
        question_statement: `Date of Expiration`,
        question_type: "date",
        answer: "",
        type: "date",
        is_required: true,
        created_for: "date_of_expiration",
        question_id: "Z5bqEO",
      },
    ],
  },
  // ============================================================
  // LANGUAGE PROFICIENCY ASSESSMENT & SUPPORT SERVICES
  // ============================================================
  {
    title: "Language Proficiency Assessment",
    value: "language_assessment_support_services",
    intro_text: `This section helps Little Haiti Global (LHG) assess language proficiency and determine whether
    optional language support services may be beneficial during the resettlement period.`,
    has_sub_sections: false,
    is_completed: false,
    _id: "683d30eb8ed9ddeb5b99b4e7",
    questions: [
      {
        question_id: "LangQ1",
        question_number: 1,
        question_statement: "Do you speak English?",
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: false,
        created_for: "language_support",
      },
      {
        question_id: "LangQ2",
        question_number: 2,
        question_statement:
          "How would you rate your ability to communicate in English?",
        question_type: "radio",
        options: [
          { label: "Beginner", value: "beginner" },
          { label: "Intermediate", value: "intermediate" },
          { label: "Fluent", value: "fluent" },
        ],
        answer: "",
        is_required: false,
        created_for: "language_support",
      },
      {
        question_id: "LangQ3",
        question_number: 3,
        question_statement: "Do you speak French?",
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: false,
        created_for: "language_support",
      },
      {
        question_id: "LangQ4",
        question_number: 4,
        question_statement:
          "How would you rate your ability to communicate in French?",
        question_type: "radio",
        options: [
          { label: "Beginner", value: "beginner" },
          { label: "Intermediate", value: "intermediate" },
          { label: "Fluent", value: "fluent" },
        ],
        answer: "",
        is_required: false,
        created_for: "language_support",
      },
      {
        question_id: "LangQ5",
        question_number: 5,
        question_statement:
          "In your native language, are you able to read and write Haitian Creole?",
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: false,
        created_for: "language_support",
      },
      {
        question_id: "LangQ6",
        question_number: 6,
        question_statement:
          "Based on your current English proficiency, do you believe you may require language instruction support?",
        question_type: "radio",
        options: [
          { label: "No language instruction needed", value: "no_need" },
          { label: "Approximately 6 months of English instruction", value: "6_months" },
          { label: "Approximately 12 months of English instruction", value: "12_months" },
        ],
        answer: "",
        is_required: true,
        created_for: "language_support",
      },
      {
        question_id: "LangQ7",
        question_number: 7,
        question_statement:
          "Are you interested in learning the primary language of your host country, if different from your current language skills?",
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: true,
        created_for: "language_support",
      },

    ],
  },
  // ============================================================
  // OPTIONAL WELLNESS & SUPPORT SERVICES (VOLUNTARY)
  // ============================================================
  {
    title: "Optional Wellness & Support Services (Voluntary)",
    value: "optional_wellness_support_services",
    intro_text: `LHG offers optional wellness and support services designed to assist participants with
    adjustment, well-being, and successful integration. Participation in these services is entirely
    voluntary and not a requirement of the program.`,
    has_sub_sections: false,
    is_completed: false,
    _id: "683d30eb8ed9wall5b99b4e7",
    questions: [
      {
        question_id: "WellQ1",
        question_number: 1,
        question_statement: "If offered, are you interested in receiving wellness and well-being support services?",
        question_type: "radio",
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        answer: "",
        is_required: false,
        created_for: "optional_wellness_support_services",
      },
      // {
      //   question_id: "WellQ2",
      //   question_number: 2,
      //   question_statement: "If available, would you be interested in optional counseling or mental health support services provided through the program or partner organizations?",
      //   question_type: "radio",
      //   options: [
      //     { label: "Yes", value: "yes" },
      //     { label: "No", value: "no" },
      //   ],
      //   answer: "",
      //   is_required: false,
      //   created_for: "optional_wellness_support_services",
      // },
    ],
  },
  // ============================================================
  // REQUIRED DOCUMENTATION (PDF OR JPEG FORMAT ONLY)
  // ============================================================
  {
    title: "Required Documentation (PDF or JPEG format ONLY)",
    value: "required_documentation",
    has_sub_sections: false,
    is_completed: false,
    _id: "683d30eb8ed9ddeb5b99b4e8",

    questions: [
      {
        question_statement: `Passport-size photograph (2x2", white background)`,
        question_type: "file",
        answer: "",
        is_required: true,
        created_for: "passport_size_photograph",
        question_id: "Z9mqEO",
      },
      {
        question_statement: `Passport data page`,
        question_type: "file",
        answer: "",
        is_required: true,
        created_for: "passport_data_page",
        question_id: "Z9nqEO",
      },
      {
        question_statement: `Upload Your DCPJ Police Clearance Certificate`,
        question_type: "file",
        answer: "",
        is_required: true,
        created_for: "dcpj_data_page",
        question_id: "Z9nqEK",
      },
      {
        question_statement: `Optional: Immunization Record (Valid COVID-19 vaccine, Yellow fever certificate or any other record)`,
        question_type: "file",
        answer: "",
        is_required: false,
        created_for: "immunization_record",
        question_id: "Z9oqEO",
      },
      {
        question_statement: `I confirm that I have uploaded all required documents.`,
        question_type: "boxwithcheck",
        answer: "",
        is_required: true,
        created_for: "required_documentation_confirmation",
        question_id: "Z9opEO",
      },
      {
        question_statement: `All uploaded documents are accurate and legible.`,
        question_type: "boxwithcheck",
        answer: "",
        is_required: true,
        created_for: "required_documentation_confirmation",
        question_id: "Z9oqEO",
      },
    ],
  },
  // ============================================================
  // REFERENCE CONTACT INFORMATION
  // ============================================================
  {
    title: "Reference Contact Information",
    value: "sponsor_or_reference_contact_information",
    has_sub_sections: false,
    is_completed: false,
    _id: "683d30eb8ed9ddeb5b99b4e3",
    questions: [
      {
        question_statement: `Organization `,
        question_type: "text",
        answer: "",
        type: "text",
        is_required: false,
        created_for: "Organization ",
        question_id: "3RbqEO",
      },
      {
        question_statement: `Choose Title`,
        question_type: "dropdown",
        options: [
          { label: "Mr.", value: "mr" },
          { label: "Mrs.", value: "mrs" },
          { label: "Ms.", value: "ms" },
          { label: "Dr.", value: "dr" },
          { label: "Miss", value: "miss" },
        ],
        answer: "",
        is_required: false,
        created_for: "title_reference_contact",
        question_id: "4NbHwi",
      },
      {
        question_statement: `First Name`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "first_name",
        question_id: "4AbqEO",
      },
      {
        question_statement: `Last Name`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "last_name",
        question_id: "4BbqEO",
      },
      {
        question_statement: `Address`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "address",
        question_id: "4CbqEO",
      },
      {
        question_statement: `Address Line 2`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: false,
        created_for: "address_line",
        question_id: "4CbqEO",
      },
      {
        question_statement: `City`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "city",
        question_id: "4DbqEO",
      },
      {
        question_statement: `State/Province/Territory`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "state",
        question_id: "4FbqEO",
      },
      {
        question_statement: `Zip Code or Country Code `,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: true,
        created_for: "zip_code_or_country_code ",
        question_id: "4GbqEO",
      },
      {
        question_statement: `Email`,
        question_type: "text",
        type: "email",
        answer: "",
        is_required: true,
        created_for: "email",
        question_id: "4FbqEO",
      },
      {
        question_statement: `Mobile Number`,
        question_type: "text",
        type: "number",
        answer: "",
        is_required: true,
        created_for: "mobile_number",
        question_id: "4JbqEO",
      },
      {
        question_statement: `Other Number`,
        question_type: "text",
        type: "number",
        answer: "",
        is_required: false,
        created_for: "other_number",
        question_id: "4HbqEO",
      },
      {
        question_statement: `Occupation`,
        question_type: "text",
        type: "text",
        answer: "",
        is_required: false,
        created_for: "occupation",
        question_id: "4KbqEO",
      },
    ],
  },
  // ============================================================
  // APPLICATION REVIEW
  // ============================================================
  {
    title: "Application Review",
    value: "application_review_and_certification",
    has_sub_sections: false,
    is_completed: false,
    _id: "683d30eb8ed9ddeb5b99b4e9",

    questions: [
      {
        question_statement: `Please review all sections of your application to ensure accuracy before submitting. Check here when completed. `,
        question_type: "radio",
        options: [{ label: "Yes", value: "yes" }],
        answer: "",
        is_required: true,
        created_for: "application_review_completed",
        question_id: "Z9orEO",
      },
    ],
  },
  // ============================================================
  // CERTIFICATION, ELECTRONIC SIGNATURE, AND CONSENT
  // ============================================================
  {
    title: "Certification, Electronic Signature, and Consent",
    value: "certification",
    has_sub_sections: false,
    is_completed: false,
    questions: [
      {
        question_statement: `I hereby certify that all information provided in this application, including all statements and
        supporting documentation, is true, complete, and accurate to the best of my knowledge and
        belief. I understand and acknowledge that any false, misleading, or incomplete information, or
        omission of material facts, may result in the denial, revocation, or disqualification of my
        application from the Little Haiti Global (LHG) Program at any stage of the review process.`,
        question_type: "statement",
        is_required: false,
        created_for: "certification_description",
        question_id: "Z9osEO1",
        is_not_show_ans: true,
      },
      {
        question_statement: `I further understand and agree that all information and documentation submitted as part of this
        application is subject to verification by authorized representatives of Little Haiti Global and,
        where applicable, by authorized entities in the United States and the designated host country.`,
        question_type: "statement",
        is_required: false,
        created_for: "certification_description",
        question_id: "Z9otEO2",
        is_not_show_ans: true,
      },
      {
        question_statement: `By submitting this application, I acknowledge and agree that the processing and review of my
        application are contingent upon the full and timely payment of all required program fees. I
        understand that failure to remit the required fees will result in my application not being
        processed or being deemed null and void. I further acknowledge that all required fees must be
        paid online prior to the commencement of the application review process.
`,
        question_type: "statement",
        is_required: false,
        created_for: "certification_description",
        question_id: "Z9otEO3",
        is_not_show_ans: true,

      },
      {
        question_statement: `The required fees are as follows:`,
        question_type: "heading",
        is_required: false,
        created_for: "certification_description",
        question_id: "Z9otEV4",
        is_not_show_ans: true,
      },
      {
        question_statement: `Application Processing Fee: $1,500.00 USD (non-refundable).`,
        question_type: "statement",
        is_required: false,
        created_for: "certification_description",
        question_id: "Z9otEV5",
        is_not_show_ans: true,
      },
      {
        question_statement: `Investment Fee: $10,000.00 USD, due upon initial application approval.`,
        question_type: "statement",
        is_required: false,
        created_for: "certification_description",
        question_id: "Z9otEM6",
        is_not_show_ans: true,
      },
      {
        question_statement: `Electronic Signature Authorization`,
        question_type: "heading",
        is_required: false,
        created_for: "certification_description",
        question_id: "Z9otEM7",
        is_not_show_ans: true,
      },
      {
        question_statement: `By typing my name below, checking the acknowledgment box, or submitting this application
        electronically, I understand and agree that I am providing my <strong>Electronic Signature</strong>, which carries
        the same legal force and effect as a handwritten signature. I consent to the use of electronic
        records, electronic signatures, and electronic delivery of all notices, disclosures, and
        communications related to this application and my participation in the Little Haiti Global
        Program.`,
        question_type: "description",
        is_required: false,
        created_for: "certification_description",
        question_id: "Z9otEM8",
        is_not_show_ans: true,
      },
      {
        question_statement: "Please type your full name",
        question_type: "text",
        type: "text",
        is_required: true,
        created_for: "applicant_full_name_signature",
        question_id: "Z9ovEO10",
      },
      {
        question_statement: "Please sign below electronically",
        question_type: "electronic_sign",
        is_required: true,
        created_for: "electronic_sign",
        question_id: "Z9owEO11",
      },
      {
        question_statement: `I acknowledge and agree that my electronic signature is legally binding`,
        question_type: "boxwithcheck",
        answer: "",
        is_required: true,
        created_for: "application_review_completed",
        question_id: "Z9ouEO12",
      },
      {
        question_statement: `I confirm that I have read, understood, and voluntarily agree to all terms, conditions,
        certifications, and disclosures contained in this application`,
        question_type: "boxwithcheck",
        answer: "",
        is_required: true,
        created_for: "application_review_completed",
        question_id: "Z9ouEO9",
      },
    ],
  },
  // ============================================================
  // ACKNOWLEDGMENT AND SUBMISSION
  // ============================================================
  {
    title: "Acknowledgment and Submission",
    value: "processing_fee_and_submission",
    _id: "683d30eb8ed9ddeb5b99b4ea",
    intro_text: `Please review and acknowledge each statement below before submitting your application to the
    Little Haiti Global (LHG) Program:`,
    has_sub_sections: false,
    is_completed: false,
    questions: [
      {
        question_statement: ``,
        question_type: "checkbox",
        options: [
          {
            label:
              "I certify that I meet the basic eligibility requirements of the Little Haiti Global Program, including age eligibility, Haitian nationality, absence of a criminal record, and compliance with all program criteria as outlined in this application.",
            value: "acknowledgement",
          },
          {
            label: "I understand that participation in the program is contingent upon the submission of complete, accurate, and truthful information, including all required supporting documentation such as passport details, photographs, visa-related information, background disclosures, and any additional verification materials requested during the review process",
            value: "refundable",
          },
          {
            label:
              "I understand and consent to background, identity, and eligibility verification, which may be conducted by authorized representatives of Little Haiti Global and, where applicable, by authorities in the United States and the designated host country",
            value: "agreement",
          },
          {
            label:
              "I understand that the Application Processing Fee of $1,500.00 USD is non-refundable and must be paid before my application can be submitted or reviewed.",
            value: "processingfee",
          },
          {
            label:
              "I understand that the Investment Fee of $10,000.00  USD is non-refundable and is due only upon initial application approval.",
            value: "investmentfee",
          },
          {
            label:
              "I acknowledge that failure to meet eligibility requirements, submit required documentation, pass verification checks, or comply with program policies may result in denial or disqualification, regardless of fee payment.",
            value: "acknowledgementtwo",
          },
          {
            label:
              "I have read, understood, and agree to comply with the Terms and Conditions and Terms of Use of the Little Haiti Global Program.",
            value: "termsandconditions",
          },
        ],
        answer: "",
        is_required: true,
        created_for: "acknowledgement",
        question_id: "Z9oyEO",
      },
      {
        question_statement: `<p>By completing payment of the <strong>$1,500.00 USD Application Processing Fee</strong>, I understand that
        my application will be formally submitted for review. Upon successful submission, a confirmation
        message will be displayed outlining the next steps, including notification regarding payment of
        the <strong>$10,000.00 USD Investment Fee</strong>, which is required only after approval of the application.</p> 
        <p><strong>Reminder:</strong> The Application Processing Fee must be paid in full before the application can be
        submitted or processed.</p>`,
        question_type: "description",
        answer: "",
        is_required: true,
        created_for: "submit",
        question_id: "Z9ozEO",
      },
    ],
  },
];
